import {ComplianceManagerApi} from "../compliance-manager";
import ComplianceManagerTabs from "./tabs";
import ComplianceManagerOverallStatus from "./overall-status";
import React from "react";
import './ui.style.less';
import {Alert, Button} from "antd";
import {ComplianceCheckButton} from "./check-button";
import OverridePanelDrawer from "./override-panel-drawer";
import CenteredLoadingScreen from "../../../CenteredLoadingScreen";
import {cleanGraphQLErrorMsg} from "../../../../common/util";

export interface ComplianceManagerUIProps {
    api: ComplianceManagerApi
}

/**
 * Defines the main UI of the ComplianceManager component.
 */
const ComplianceManagerUI: React.FC<ComplianceManagerUIProps> = (props) => {

    if (props.api.complianceChecker.validationMessage) {
        return <div className="mc-compliance-manager-body">
            <Alert
                type="warning"
                showIcon
                message="Complete the required fields"
                description={props.api.complianceChecker.validationMessage}
            />
        </div>;
    }

    const error = props.api.complianceChecker?.error ? (
        <Alert
            type="error"
            showIcon
            message="Failed to run compliance check"
            description={cleanGraphQLErrorMsg(String(props.api.complianceChecker?.error))}
            banner
            style={{ marginBottom: 12 }}
        />
    ) : null

    const content = <>
        {error}
        <div style={{ marginTop: 24 }}>
            <ComplianceManagerOverallStatus api={props.api} />
        </div>
        <OverridePanelDrawer api={props.api} />
        <ComplianceManagerTabs api={props.api} />
    </>;

    const loading = <CenteredLoadingScreen />

    return <div className="mc-compliance-manager-body">
        <ComplianceCheckButton api={props.api} />
        {props.api.complianceChecker.loading && !props.api.complianceChecker.error ? loading : content}
    </div>;
}

export default ComplianceManagerUI;
